/**
 * Product Variant Selection Handler
 * Handles variant changes, price updates, and variant matching
 */
(function () {
  'use strict';

  // Function to get product JSON data
  function getProductJson(sectionId) {
    const productJsonElement = document.getElementById(`ProductJson-${sectionId}`);

    if (productJsonElement && productJsonElement.textContent) {
      try {
        return JSON.parse(productJsonElement.textContent);
      } catch (error) {
        console.error('Error parsing product JSON:', error);
      }
    }

    const productForm = document.querySelector(`.product__info-wrapper product-form[data-section-id="${sectionId}"]`);
    if (productForm && productForm.dataset.variants) {
      try {
        const variants = JSON.parse(productForm.dataset.variants);
        if (variants && Array.isArray(variants)) {
          return { variants: variants };
        }
      } catch (error) {
        console.error('Error parsing variants from product-form:', error);
      }
    }

    return null;
  }

  function handleVariantChange(selects, sectionId, productData, productForm) {
    const selectedOptions = Array.from(selects).map(select => select.value);
    const variants = productData.variants;

    if (!variants || !Array.isArray(variants)) {
      console.error('Invalid variants data');
      return;
    }

    const matchingVariant = findMatchingVariant(variants, selectedOptions);

    if (matchingVariant) {
      updateProductInfo(matchingVariant, productForm, sectionId);
    } else {
      updateSubscriptionButtonStates(null);
    }
  }

  function updateProductInfo(variant, productForm, sectionId) {
    // Update variant ID in form
    const variantInput = productForm.querySelector('[name="id"]');
    if (variantInput) {
      variantInput.value = variant.id;
    }

    // Update price display
    const priceContainer = document.getElementById(`price-container-${sectionId}`);
    if (priceContainer) {
      let priceHtml = '<div id="price-' + sectionId + '">';

      // Main price always comes first
      priceHtml += `
      <div class="product-price">
        <span class="currency">$</span>
        <span class="dollars">${(variant.price / 100).toFixed(2).split('.')[0]}</span>
        <span class="cents">${(variant.price / 100).toFixed(2).split('.')[1]}</span>
      </div>
    `;

      // Compare at price comes second (if there's a discount)
      if (variant.compare_at_price > variant.price) {
        priceHtml += `
        <div class="product-card__price-compare-at-price">
          <div class="product-price">
            <span class="currency">$</span>
            <span class="dollars">${(variant.compare_at_price / 100).toFixed(2).split('.')[0]}</span>
            <span class="cents">${(variant.compare_at_price / 100).toFixed(2).split('.')[1]}</span>
          </div>
        </div>
      `;
      }

      priceHtml += '</div>';
      priceContainer.innerHTML = priceHtml;
    }

    // Update variant title
    const variantTitleElement = document.querySelector('.product__variant-title');
    if (variantTitleElement) {
      variantTitleElement.textContent = variant.title;
    }

    // Update button states
    updateSubscriptionButtonStates(variant);

    // Update SKU for reviews
    const reviewsContainer = document.querySelector('[data-reviews-container]');
    if (reviewsContainer) {
      reviewsContainer.dataset.productSku = variant.sku;
    }

    // Update media
    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && variant.featured_media) {
      if (typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(variant.featured_media.id);
      }
    }

    // Get current quantity
    const quantityInput = document.querySelector('quantity-input .quantity__input');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    // Update Recharge widget prices
    updateOriginalRechargeWidgetPrices(variant, quantity);
    setTimeout(() => updateRechargeWidgetPrices(variant, quantity), 300);
  }

  function updateSubscriptionButtonStates(variant) {
    const subscribeButton = document.querySelector('.subscribe-and-save .subscribe-and-save-button');
    const oneTimeButton = document.querySelector('.one-time-purchase .subscribe-and-save-button');
    const quickAddButton = document.querySelector('.main-product .product-form__submit');

    const isAvailable = variant && variant.available;

    if (subscribeButton) {
      subscribeButton.disabled = !isAvailable;
      subscribeButton.textContent = isAvailable ? 'Subscribe' : 'Out of Stock';
      subscribeButton.style.opacity = isAvailable ? '1' : '0.5';
      subscribeButton.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
    }

    if (oneTimeButton) {
      oneTimeButton.disabled = !isAvailable;
      oneTimeButton.textContent = isAvailable ? 'Add to Cart' : 'Out of Stock';
      oneTimeButton.style.opacity = isAvailable ? '1' : '0.5';
      oneTimeButton.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
    }

    if (quickAddButton) {
      quickAddButton.disabled = !isAvailable;
      quickAddButton.textContent = isAvailable ? 'Add to Cart' : 'Out of Stock';
      quickAddButton.style.opacity = isAvailable ? '1' : '0.5';
      quickAddButton.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
    }
  }

  function findMatchingVariant(variants, selectedOptions) {
    return variants.find(variant => {
      return selectedOptions.every((option, index) => {
        const optionIndex = index + 1;
        return variant[`option${optionIndex}`] === option;
      });
    });
  }

  function getCurrentVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || document.querySelector('meta[name="variant-id"]')?.content;

    if (variantId) {
      const variantSelectsContainer = document.querySelector('variant-selects');
      if (variantSelectsContainer) {
        const sectionId = variantSelectsContainer.dataset.section;
        const productData = getProductJson(sectionId);
        if (productData && productData.variants) {
          return productData.variants.find(v => v.id.toString() === variantId);
        }
      }
    }

    const productForm = document.querySelector('product-form form');
    if (productForm) {
      const variantInput = productForm.querySelector('[name="id"]');
      if (variantInput && variantInput.value) {
        const variantSelectsContainer = document.querySelector('variant-selects');
        if (variantSelectsContainer) {
          const sectionId = variantSelectsContainer.dataset.section;
          const productData = getProductJson(sectionId);
          if (productData && productData.variants) {
            return productData.variants.find(v => v.id.toString() === variantInput.value);
          }
        }
      }
    }

    const variantSelectsContainer = document.querySelector('variant-selects');
    if (variantSelectsContainer) {
      const sectionId = variantSelectsContainer.dataset.section;
      const productData = getProductJson(sectionId);
      if (productData && productData.variants) {
        return productData.variants.find(v => v.available) || productData.variants[0];
      }
    }

    return null;
  }

  // Expose getCurrentVariant globally for use by other scripts
  window.getCurrentVariant = getCurrentVariant;

  function initializePriceDisplay() {
    const priceContainer = document.querySelector('[id^="price-container-"]') || document.querySelector('.product__price-container');
    if (priceContainer) {
      priceContainer.style.display = 'block';
      priceContainer.style.visibility = 'visible';
    }
  }

  // Initialize variant handlers
  document.addEventListener('DOMContentLoaded', function () {
    const variantSelectsContainers = document.querySelectorAll('variant-selects');

    variantSelectsContainers.forEach(container => {
      const sectionId = container.dataset.section;
      if (!sectionId) {
        console.error('Missing section ID on variant-selects');
        return;
      }

      const productData = getProductJson(sectionId);
      if (!productData) {
        console.error('Could not find product data for section:', sectionId);
        return;
      }

      const selects = container.querySelectorAll('select');
      if (selects.length === 0) return;

      const formId = selects[0].getAttribute('form');
      if (!formId) return;

      const productForm = document.getElementById(formId);
      if (!productForm) return;

      selects.forEach(select => {
        select.addEventListener('change', function () {
          handleVariantChange(selects, sectionId, productData, productForm);
        });
      });
    });

    initializePriceDisplay();
  });

})();